import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'https://api-reunibox-uplxw.run-eu-central1.goorm.io/',
  // Pilotée par le build : l'application de recette (test.reunibox.com) tape
  // sur api-test.reunibox.com, qui porte les clés Stripe de test. Défaut =
  // production, pour qu'un build sans la variable se comporte comme avant.
  baseURL: process.env.VUE_APP_APIURL || 'https://api.reunibox.com/',
  // timeout: 1000,
  // headers: { 'X-Custom-Header': 'foobar' },
  headers: {
	  'Access-Control-Allow-Origin': '*',
	  'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
	  'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
	},
})

Vue.prototype.$http = axiosIns

export default axiosIns
